import Autolinker from 'autolinker';

var autolinker = new Autolinker({
    urls: {
        schemeMatches: false,
        wwwMatches: false,
        tldMatches: false
    },
    email: false,
    phone: true,
    mention: false,
    hashtag: false,

    stripPrefix: true,
    stripTrailingSlash: true,
    newWindow: false,

    truncate: {
        length: 0,
        location: 'end'
    },

    className: ''
});

function contains(selector, text) {
    var elements = document.querySelectorAll(selector);
    return Array.prototype.filter.call(elements, function(element) {
        return RegExp(text.replace(/\(/g, '\\(').replace(/\)/g, '\\)')).test(element.textContent);
    });
}

export function convertPhoneNumbersToLinks() {
    var body = document.querySelector('body');
    var phoneMatches = autolinker.parse(body.textContent);
    for (var i = 0; i < phoneMatches.length; i++) {
        var pElementsToLink = contains('p', phoneMatches[i].getMatchedText());
        for (var j = 0; j < pElementsToLink.length; j++) {
            var pElementToLink = pElementsToLink[j];
            pElementToLink.innerHTML = autolinker.link(pElementToLink.innerHTML);
        }
        var spanElementsToLink = contains('span', phoneMatches[i].getMatchedText());
        for (j = 0; j < spanElementsToLink.length; j++) {
            var spanElementToLink = spanElementsToLink[j];
            spanElementToLink.innerHTML = autolinker.link(spanElementToLink.innerHTML);
        }
    }
}
